import {Component, Input} from '@angular/core';
import {CardMessage} from "./card-message";

@Component({
    selector: 'form-card',
    templateUrl: './form-card.component.html',
})
export class FormCardComponent {

    @Input()
    message: CardMessage;
    constructor() {
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/card/form-card.component.ts